module.exports = __webpack_public_path__ + "media/images/help/image2-53cd6fa85ba8302d218b99bd7b07fb0d.jpeg";